export class UnauthorizedIntegration extends Error {
  public constructor() {
    super()

    this.message = 'errors.unauthorizedIntegration'
  }
}
